export default [{
  path: '/credit/index',
  name: 'credit-index',
  title: '赊账管理',
  redirect: '/credit/index',
  component: () => import('@/views/credit/index'),
  children: [{
    path: '/credit/index',
    name: 'credit-index',
    title: '赊账管理',
    component: () => import('@/views/credit/template/manage_gzlb')
  }, {
    path: '/credit/record',
    name: 'credit-record',
    title: '赊账管理',
    component: () => import('@/views/credit/template/manage_zhkjl')
  }]
}];
